import React from "react";
import { InfoCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";

type Props = {
  isActive: boolean;
  text: string;
};

export const DomainInfoToast = ({ text, isActive }: Props) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  if (!isActive) return <></>;

  return (
    <div className="d-flex align-items-center py-2 px-3 bg-primary-info rounded-3 ms-0 ms-md-2 pe-auto">
      <InfoCircle className="text-primary me-2 flex-shrink-0 fs-6" />
      <p className="text-primary m-0">
        {text}
        <a
          href={`${process.env.REACT_APP_ME_PAGE_URL}${lng}/pricing/#pricingSection`}
          className="text-decoration-underline ms-1"
        >
          {t("payment.Premium Plan")}
        </a>
      </p>
    </div>
  );
};
